import { Component, OnInit } from '@angular/core';
import { ListLoader } from '../../../shared/components/list-loader/list-loader';
import { Ech0134GrundbuchmeldungSearchRequest, EchGrundbuchmeldungListEntry } from '../../../core/grundbuchmeldung-api';
import { TableSortModel } from '../../../shared/tablesort/tableSortModel';
import { ActivatedRoute, Router } from '@angular/router';
import { ComparatorService } from '../../../shared/services/comparator-service';
import { Location } from '@angular/common';
import { CapAlertService } from '../../../core/extension/exceptions/cap-alert.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ContentHeaderComponent } from '../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { Ech0134GrundbuchmeldungTableComponent } from '../grundbuchmeldung-table/ech0134-grundbuchmeldung-table.component';
import { keysToTranslate } from '../../../../i18n/keys-to-translate';

@Component({
  selector: 'cap-ech0134-grundbuchmeldung-list',
  templateUrl: './ech0134-grundbuchmeldung-list.component.html',
  styleUrls: ['./ech0134-grundbuchmeldung-list.component.scss'],
  imports: [ContentHeaderComponent, TitleComponent, Ech0134GrundbuchmeldungTableComponent, TranslatePipe]
})
export class Ech0134GrundbuchmeldungListComponent implements OnInit {
  listLoader: ListLoader<EchGrundbuchmeldungListEntry>;
  tableSortModel = new TableSortModel<EchGrundbuchmeldungListEntry>('table', this.comparatorService);

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private comparatorService: ComparatorService,
    private location: Location,
    private capAlertService: CapAlertService,
    private translate: TranslateService
  ) {
    keysToTranslate<string>([
      'ech0134.grundbuchmeldungen.datumVersandBis',
      'ech0134.grundbuchmeldungen.datumVersandVon',
      'ech0134.grundbuchmeldungen.status'
    ]);
  }

  ngOnInit() {
    this.listLoader = this.route.snapshot.data.listLoader;
    this.tableSortModel.addColumn(
      'geschaeftsNummer',
      undefined,
      Ech0134GrundbuchmeldungSearchRequest.GrundbuchmeldungSortEnum.GESCHAEFTS_NUMMER
    );
    this.tableSortModel.addColumn(
      'empfaengerBezeichnung',
      undefined,
      Ech0134GrundbuchmeldungSearchRequest.GrundbuchmeldungSortEnum.EMPFAENGER_BEZEICHNUNG
    );
    this.tableSortModel.addColumn(
      'empfaengerSedexId',
      undefined,
      Ech0134GrundbuchmeldungSearchRequest.GrundbuchmeldungSortEnum.EMPFAENGER_SEDEX_ID
    );
    this.tableSortModel.addColumn(
      'meldungsStatus',
      undefined,
      Ech0134GrundbuchmeldungSearchRequest.GrundbuchmeldungSortEnum.MELDUNGS_STATUS
    );
    this.tableSortModel.addColumn('datumMeldung', undefined, Ech0134GrundbuchmeldungSearchRequest.GrundbuchmeldungSortEnum.DATUM_VERSAND);
    this.listLoader.applySortModel(this.tableSortModel);
  }
}
